<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <div v-if="job && pharmacy && arrayApplications?.length !== 1">

      <ion-title v-if="job.startDate">
        <template v-if="checkJobDateStart(job.startDate, job.endDate)">
          <span>{{ checkJobDateStart(job.startDate, job.endDate, true) }}</span> -
        </template>
        <span>{{ $moment(job.endDate, "YYYY/MM/DD").format("D MMM") }}</span>
      </ion-title>
    </div>
    <div v-else-if="job && pharmacy">
      <ion-title>{{ $moment(arrayApplications[0]?.shift?.date, "YYYY/MM/DD").format("D MMM") }}</ion-title>

    </div>
  </ion-toolbar>
  <div class="main_wrapper ion-padding" v-if="job && pharmacy && shift">
    <div class="container">
      <div class="auth-header">
                <div class="auth-heading">
                    <h1>Shift</h1>
                    <div class="title">
                        <span>Accept the offer</span>
                        
                    </div>
                   
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
      <div class="job_info_wrapper">
        <div class="image_text_comp d-block">
          <div class="image_wrapper">
            <el-avatar :size="'small'" shape="square" :src="pharmacy.image" v-if="pharmacy.image" />
            <el-avatar :size="'small'" shape="square" icon="el-icon-user-solid" v-else></el-avatar>
          </div>
          <div class="text_wrapper mt-2">
            <div class="main_text">{{ pharmacy.name }}</div>
            <div class="additional_text">
              <span class="distance">
                <span class="locumate_icons locumate_icon-cursor"></span>
                <span v-if="displayDistance != null">{{ distanceInMiles(displayDistance, 'km', true) }}</span>
                <span class="symb_infinity" v-else></span>
                <span class="symb_dot"></span>
              </span>
              <span>{{ $filters.addressText(pharmacy.address) }}</span>
            </div>
          </div>
        </div>
        <el-collapse class="mt-3" accordion @change="handleChange">
          <el-collapse-item class="card-accordeon" title="More about the job" name="first">
            <div class="collapse-list">
              <div class="collapse-item">
                <div class="collapse-value" v-if="arrayApplications?.length !== 1">
                  <template v-if="checkJobDateStart(job.startDate, job.endDate)">
                    <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span> -
                  </template>
                  <span>{{
                      $moment(job.endDate, "YYYY/MM/DD").format("D MMMM")
                    }}</span>
                </div>
                <div v-else class="collapse-value">
                  <span>{{
                      $moment(arrayApplications[0]?.shift?.date, "YYYY/MM/DD").format("D MMMM")
                    }}</span>

                </div>
              </div>
              <div class="collapse-item" v-if="!job.isInternalStaffOfThisPharmacy || job.isVisibileAsInternalLocum === false">
                <span class="collapse-title">Hourly Rate (excluding super)</span>
                <span class="collapse-value">
                  {{
                    formatHourlyRate(
                      job.recommendedRate,
                      job.recommendedWeekendRate
                    )
                  }}</span>
              </div>
              <div v-if="job.settings.language" class="collapse-item">
                <span class="collapse-title">Language</span>
                <span class="collapse-value">{{ job.settings.language }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Solo Pharmacist</span>
                <span class="collapse-value">{{
                  job.settings.solo == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">{{ message.Immuniser }} req?</span>
                <span class="collapse-value">{{
                  job.covidCertRequired == 0
                  ? "Not Required"
                  : job.covidCertRequired == 1
                    ? "Mandatory"
                    : "Nice to Have"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Number of technicians</span>
                <span class="collapse-value">{{ job.settings.numOfTech }}</span>
              </div>
              <div class="collapse-item" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                <span class="collapse-title">Travel</span>
                <!-- <span class="collapse-value">${{job.maxTravelCompensation}}</span> -->
                <span class="collapse-value">Capped Travel</span>
              </div>
              <div class="collapse-item" v-else>
                <span class="collapse-title">Paying for Travel(>50KM roundtrip)</span>
                <span class="collapse-value">{{
                  job.settings.payingForTravel == 0
                  ? "No travel"
                  : job.settings.payingForTravel == 1
                    ? "Partial travel"
                    : "Full travel"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Flights</span>
                <span class="collapse-value">{{
                  job.settings.payForFlights == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Accomodation</span>
                <span class="collapse-value">{{
                  job.settings.payForAccommodation == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item" v-if="isAustralia">
                <span class="collapse-title">Dosage Administration Aids</span>
                <span class="collapse-value">{{
                  job.settings.adminAids == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Open Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.openUp == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Close Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.close == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div v-if="job.settings.notes" class="collapse-item">
                <span class="collapse-title">Notes</span>
                <span class="collapse-value">{{ job.settings.notes }}</span>
              </div>
              <div v-if="job.settings.parking" class="collapse-item">
                <span class="collapse-title">Parking</span>
                <span class="collapse-value">{{ job.settings.parking }}</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-form class="job_shifts_wrapper full_page" :label-position="'top'" @submit.prevent="submit()">
        <el-form-item class="mb0" prop="jobShifts">
          <div class="mb-3 shift-cards" v-for="(item,index) in arrayApplications" :key="index">
            <div :class="item.shift.confirmedHours ? 'confirmedHours' : ''" class="job_shift_text">
              <div class="job_shift_text__item">
                <div class="day_name date">
                  {{ $moment(item.shift.date, "YYYY/MM/DD").format("ddd") }}
                  {{ $moment(item.shift.date, "YYYY/MM/DD").format("D MMM, YYYY") }}
                </div>
                <div class="day_time">
                  <span>{{
                    $moment(item.shift.startTime, "HH:mm").format("h:mm A")
                  }}</span>
                  -
                  <span>{{
                    $moment(item.shift.endTime, "HH:mm").format("h:mm A")
                  }}</span>
                </div>
              </div>
              <!-- <div style="display:flex; gap:1.6rem; justify-content: space-between;">
                <div class="job_shift_text__item"
                  v-if="!item.isInternalStaffOfThisPharmacy || item.shift.isVisibileAsInternalLocum === false">
                  <div class="day_name label">Rate</div>
                  <div class="day_time">
                    <span v-if="showShiftInformation(item.shift)">
                      {{ Rate(item.shift) }}</span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="job_shift_text__item">
                  <div class="day_name label">Hours</div>
                  <div class="day_time">
                    <span v-if="showShiftInformation(item.shift)">
                      {{
                        confirmedHours(
                          item.shift.confirmedHours,
                          item.shift.startTime,
                          item.shift.endTime
                        )
                      }}</span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="job_shift_text__item"
                  v-if="!item.isInternalStaffOfThisPharmacy || item.shift.isVisibileAsInternalLocum === false">
                  <div class="day_name label" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                    <span>Capped Travel</span>
                  </div>
                  <div class="day_name label" v-else>
                    <span>Travel</span>
                  </div>
                  <div class="day_time">
                    <span v-if="showShiftInformation(item.shift)">
                      {{ travelCompensationCount(job, item.shift) }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="job_shift_text__item"
                  v-if="!item.isInternalStaffOfThisPharmacy || item.shift.isVisibileAsInternalLocum === false">
                  <div class="day_name label">Sum</div>
                  <div class="day_time">
                    <span v-if="showShiftInformation(item.shift)">
                      {{ Sum(item.shift) }}</span>
                    <span v-else>-</span>
                  </div>
                </div>
              </div> -->
              <div class="info-wrapper">
                      <div class="day_info_block">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.40001 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.40001 18.3333 10Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8417 9.69167 10.2 9.69167 9.675V6.25833"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="day_time data">
                          <span>{{
                            $moment(
                              item.shift.userStartTime || item.shift.startTime,
                              "HH:mm"
                            ).format("h:mm A")
                          }}</span>
                          -
                          <span>{{
                            $moment(
                              item.shift.userEndTime || item.shift.endTime,
                              "HH:mm"
                            ).format("h:mm A")
                          }}</span
                          >&nbsp;
                          <span v-if="showShiftInformation(shift)">
                            ({{
                              confirmedHours(
                                item.shift.confirmedHours,
                                item.shift.startTime,
                                item.shift.endTime
                              )
                            }}
                            Hours)</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block">
                        <div class="title">
                          <!-- <span>Break </span> -->
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 18.3333C5.975 18.3333 2.70833 15.0667 2.70833 11.0417C2.70833 7.01667 5.975 3.75 10 3.75C14.025 3.75 17.2917 7.01667 17.2917 11.0417"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 6.66699V10.8337"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.5 1.66699H12.5"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.8334 14.167V17.5003"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.3334 14.167V17.5003"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div class="info">
                          <span v-if="showShiftInformation(item.shift)">
                            {{
                              item.shift.userBreakMinutes
                                ? getTimeFromMinutes(item.shift.userBreakMinutes)
                                : "-"
                            }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div
                        class="day_info_block"
                        v-if="
                          !shift.shiftBookedAsInternalStaff &&
                          shift.isVisibileAsInternalLocum === false
                        "
                      >
                        <div class="title">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.72501 3.83334C2.39167 0.950004 6.73334 0.950004 7.39167 3.83334C7.78334 5.525 6.70834 6.95834 5.77501 7.85C5.09167 8.5 4.01667 8.49167 3.33334 7.85C2.40834 6.95834 1.33334 5.525 1.72501 3.83334Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                            />
                            <path
                              d="M12.5583 13.8333C13.225 10.95 17.5917 10.95 18.2583 13.8333C18.65 15.525 17.575 16.9583 16.6333 17.85C15.95 18.5 14.8667 18.4917 14.1833 17.85C13.2417 16.9583 12.1667 15.525 12.5583 13.8333Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                            />
                            <path
                              d="M9.99997 4.16699H12.2333C13.775 4.16699 14.4916 6.07533 13.3333 7.09199L6.67497 12.917C5.51664 13.9253 6.23331 15.8337 7.76664 15.8337H9.99997"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4.57185 4.58366H4.58148"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.4052 14.5837H15.4148"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          class="info"
                          v-if="job.settings.payingForTravel == 3 &&
                            job.maxTravelCompensation !== 0
                          "
                        >
                          <span>{{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Travel" : "Capped Travel" }}</span>
                        </div>
                        <div class="info" v-else>
                          <span>Travel</span>
                        </div>
                        <div class="info">
                          <span v-if="showShiftInformation(item.shift)">
                            {{ travelCompensationCount(job, item.shift, index) }}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div
                        class="day_info_block"
                        v-if="
                          !shift.shiftBookedAsInternalStaff ||
                          shift.isVisibileAsInternalLocum === false
                        "
                      >
                        <div class="title">
                          <!-- <span>Rate</span> -->
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 5V15"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span
                            class="locumate_icons locumate_icon-check shift_confirm"
                            v-if="shift.confirmationDate"
                          ></span>
                        </div>
                        <div class="info rate">
                          <span
                            v-if="
                              (showShiftInformation(item.shift) &&
                                !shift.shiftBookedAsInternalStaff) ||
                              (showShiftInformation(item.shift) &&
                                job.openMarketplaceShiftForInternalLocum)
                            "
                            >{{ Rate(item.shift) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <template v-if="isAustralia">
                        <div
                          class="day_info_block"
                          v-if="
                            !item.shift.shiftBookedAsInternalStaff ||
                            item.shift.isVisibileAsInternalLocum === false
                          "
                        >
                          <div class="title">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10 5V15"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <!-- <span>Total Super</span> -->
                          </div>
                          <div class="info amount">
                            <span>Total Super</span>
                            <span
                              v-if="
                                (showShiftInformation(item.shift) &&
                                  !shift.shiftBookedAsInternalStaff) ||
                                (showShiftInformation(item.shift) &&
                                  job.openMarketplaceShiftForInternalLocum)
                              "
                            >
                              {{ totalSuperRate(item.shift) }}</span
                            >
                            <span v-else>-</span>
                          </div>
                        </div>
                      </template>

                      <div
                        class="day_info_block"
                        v-if="
                          !item.shift.shiftBookedAsInternalStaff ||
                          item.shift.isVisibileAsInternalLocum === false
                        "
                      >
                        <div class="title">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 5V15"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <!-- <span>Sum</span> -->
                        </div>
                        <div class="info amount">
                          <span>Sum </span>
                          <span
                            v-if="
                              (showShiftInformation(item.shift) &&
                                !item.shift.shiftBookedAsInternalStaff) ||
                              (showShiftInformation(item.shift) &&
                                job.openMarketplaceShiftForInternalLocum)
                            "
                          >
                            {{ Sum(job, item.shift, index) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="jobShiftsErrors" class="button_submit mb0">
          <el-button class="submit_page" type="danger" @click="rejectSubmit()" :disabled="isButtonDisabled">
            Decline
          </el-button>
          <el-button class="submit_page" type="success" @click="submit()" :disabled="isButtonDisabled">
            Accept
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>

  <div class="el_dialog_wraper">
    <el-dialog v-model="dialogVisible" title="Shift Accepted" width="30%" @closed="handleDialogClose">
      <div class="message text-center mt-3">
        <p>Congratulations!</p>
        <p>We'll let the pharmacy know you accepted the shift</p>
        <img style="width: 200px" class="success_image" width="100%" src="@/assets/img/illustrations/success.svg"
          alt="success image" />
      </div>
      <template #footer>
        <span class="dialog-footer w-100">
          <el-button @click="redirectToCalendar" type="primary">View Calendar</el-button>
        </span>
      </template>
    </el-dialog>
  </div>

  <div class="el_dialog_wraper">
    <el-dialog v-model="rejectDialogVisible" title="" width="30%" @closed="handleDialogClose">
      <div class="message text-center mt-3">
        <p>We'll let the pharmacy know you declined the shift</p>
      </div>
      <template #footer>
        <span class="dialog-footer w-100">
          <el-button @click="redirectToCalendar" type="primary">View Calendar</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { ref, onMounted, inject, computed } from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { useStore } from "vuex";
import moment from "moment";
import timeDiff from "@/helpers/date/timeDiff";
import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
import distanceInMiles from "@/helpers/distance/distance-in-miles.js";
import { ElMessageBox } from "@/components/Vendor/Element";
import { useRouter } from "vue-router";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import SvgIcon from '@/components/Svg/SvgIcon.vue';

addIcons({
  "arrow-back-outline": arrowBackOutline,
});

import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const message = inject("messages");
    const dialogVisible = ref(false);
    const rejectDialogVisible = ref(false);

    let shiftApplication = ref($store.getters.getShiftApplicationDetails.data);
    let shiftApplicationNew = ref($store.getters.getShiftApplicationDetails.dataNew);
    let arrayApplications = shiftApplicationNew.value || [];
    let shift = ref(shiftApplication.value?.shift ?? null);
    let job = ref(shift.value?.job ?? null);
    let pharmacy = ref(shift.value?.pharmacy ?? null);

    const userData = $store.getters.GET_USER_DATA;
    const groupSubscriptionExist = ref(userData.groupSubscriptionExist ? userData.groupSubscriptionExist : false);
    const userRole = userData.role;
    const isAustralia = isAustraliaRegion();

    // Locum ShiftResource nests a slim job stub without distance; km lives on shift.distance / historyDistance.
    const pickDistance = (...candidates) => {
      for (const value of candidates) {
        if (value !== null && value !== undefined && value !== "") {
          return value;
        }
      }
      return null;
    };

    const displayDistance = computed(() => {
      const firstAppShift = arrayApplications?.[0]?.shift;
      return pickDistance(
        shift.value?.distance,
        shift.value?.historyDistance,
        firstAppShift?.distance,
        firstAppShift?.historyDistance,
        job.value?.distance
      );
    });

    onMounted(() => {
      setPageClassGlobal("shift_application_preview");

      // Accept-offer payload must include nested shift/job/pharmacy.
      if (!shift.value || !job.value || !pharmacy.value) {
        console.error("Shift application preview missing shift/job/pharmacy", {
          shiftApplication: shiftApplication.value,
        });
        $router.replace({ name: "shift_application_unavailable" });
      }
    });

    const goBack = () => {
      $router.push({
        name: 'search'
      })
    };

    const checkJobDateStart = (dateStart, endDate, trim) => {
      let start = moment(dateStart, "YYYY/MM/DD");
      let end = moment(endDate, "YYYY/MM/DD");
      if (start.format("MMMM") == end.format("MMMM")) {
        if (start.format("D") == end.format("D")) {
          return null;
        }
        return start.format("D ");
      } else {
        return start.format("D " + (trim ? "MMM" : "MMMM"));
      }
    };

    const confirmedHours = (confirmedHours, startTime, endTime) => {
      let hours = 0;
      if (confirmedHours == 0 || confirmedHours == null) {
        const start = moment(startTime, "HH:mm:ss");
        const end = moment(endTime, "HH:mm:ss");

        hours = timeDiff(start, end);
      } else {
        const string = String(confirmedHours);
        const numHours = string.split(".")[0];
        let minutes = string.split(".")[1];

        if (!minutes) {
          const time = numHours + ":" + "00";
          hours = String(time);
        } else {
          minutes = Number.parseFloat(`0.${minutes}`) * 60;
          hours = numHours + ":" + minutes.toFixed(0);
        }
      }
      return hours;
    };

    const formatHourlyRate = (regularRate, weekendRate) => {
      let formattedString = "";

      formattedString += regularRate ? "$" + regularRate : "";
      formattedString += regularRate && weekendRate ? " - " : "";
      formattedString += weekendRate ? "$" + weekendRate : "";

      return formattedString;
    };

    const showShiftInformation = (shift) => {
      if (!shift.userId) return true;
      if (shift.userId === userData.id) return true;
      return false;
    };

    const listedShiftsCount = (jobObj) => {
      if (Array.isArray(arrayApplications) && arrayApplications.length > 0) {
        return arrayApplications.length;
      }
      if (Array.isArray(jobObj?.shifts) && jobObj.shifts.length > 0) {
        return jobObj.shifts.length;
      }
      return 0;
    };

    const applyFirstLastTravelSplit = (jobObj, shift, index, travelAmount) => {
      if (
        jobObj?.isBlockShift != 1 ||
        jobObj?.enableTravelAllowanceForFirstAndLastDay != 1 ||
        shift?.adminUpdatedTravelCompensation === true
      ) {
        return travelAmount;
      }

      const shiftsLength = listedShiftsCount(jobObj);
      if (shiftsLength < 2) {
        return travelAmount;
      }

      const isFirstShift = index === 0;
      const isLastShift = index === shiftsLength - 1;
      if (isFirstShift || isLastShift) {
        return Number(travelAmount || 0) / 2;
      }
      return 0;
    };

    const resolveFullTravelAmount = (jobObj, shift) => {
      const currentJob = jobObj || job.value;
      const globalTravelCompensationValue =
        process.env.VUE_APP_TRAVEL_COMPENSATION;

      if (shift.adminUpdatedTravelCompensation === true) {
        if (
          !shift.shiftBookedAsInternalStaff ||
          shift.isVisibileAsInternalLocum === false
        ) {
          return Number(shift.travelCompensation || 0);
        }
        return 0;
      }

      if (
        shift.travelCompensation != null &&
        shift.travelCompensation !== "" &&
        Number(shift.travelCompensation) > 0
      ) {
        return Number(shift.travelCompensation);
      }

      // Stored 0/null without preset — recalculate from distance (same as booking/details).
      // Prefer shift.distance / historyDistance; locum job payload often has no distance.
      let jobDistance = pickDistance(
        shift.distance,
        shift.historyDistance,
        currentJob?.distance
      );
      if (currentJob?.isInternalStaffOfThisPharmacy) {
        jobDistance = 0;
      }
      if (!jobDistance || !currentJob?.settings?.payingForTravel) {
        return 0;
      }

      const distanceVal = jobDistance;
      if (currentJob.settings.payingForTravel == 1) {
        return distanceVal * 2 > 50
          ? (distanceVal * 2 - 50) * globalTravelCompensationValue
          : 0;
      }
      if (currentJob.settings.payingForTravel == 2) {
        return distanceVal * 2 * globalTravelCompensationValue;
      }
      if (
        currentJob.settings.payingForTravel === 3 &&
        currentJob.maxTravelCompensation !== 0
      ) {
        const realTravelCost = distanceVal * 2 * globalTravelCompensationValue;
        return realTravelCost > currentJob.maxTravelCompensation
          ? currentJob.maxTravelCompensation
          : realTravelCost;
      }
      return 0;
    };

    const travelCompensationCount = (jobObj, shift, i) => {
      const currentJob = jobObj || job.value;

      // Backend already stored split/preset amount — show as-is; 0 → "-" like booking middle days.
      if (shift.adminUpdatedTravelCompensation === true) {
        const presetAmount = Number(shift.travelCompensation || 0);
        if (presetAmount === 0) {
          return "-";
        }
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(presetAmount);
      }

      if (
        currentJob?.settings?.payingForTravel === 0
      ) {
        return "-";
      }

      let fullAmount = resolveFullTravelAmount(currentJob, shift);
      fullAmount = applyFirstLastTravelSplit(currentJob, shift, i, fullAmount);

      if (!fullAmount) {
        return "-";
      }

      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(fullAmount);
    };

    const Sum = (jobObj, shift, i) => {
      const currentJob = jobObj || job.value;
      let Sum;
      let confirmedHoursVal;
      let payRate;

      if (userRole === "locum") {
        if (shift.locum == null && shift.payRateExecSuper == null) {
          payRate = shift.recommendedRate;
        } else {
          payRate = shift.payRateExecSuper;
        }
      } else {
        payRate = shift.payRateExecSuper;
      }

      if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
        const start = moment(shift.startTime, "HH:mm:ss");
        const end = moment(shift.endTime, "HH:mm:ss");

        confirmedHoursVal = timeDiffAsDecimal(start, end);
      } else {
        confirmedHoursVal = shift.confirmedHours;
      }

      let travelCompensation = resolveFullTravelAmount(currentJob, shift);
      if (shift.adminUpdatedTravelCompensation !== true) {
        travelCompensation = applyFirstLastTravelSplit(
          currentJob,
          shift,
          i,
          travelCompensation
        );
      }

      if (payRate != null) {
        Sum = payRate * confirmedHoursVal + travelCompensation;
      } else {
        Sum = 0;
      }

      if (Sum != 0) {
        Sum = new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(Sum);
      } else {
        Sum = "-";
      }
      return Sum;
    };

    const handleChange = (e) => {
      e.stoppropagation();
    };

    const Rate = (shift) => {
      if (userRole === "locum") {
        if (shift.locum == null && shift.payRateExecSuper == null) {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.recommendedRate);
        } else {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.payRateExecSuper);
        }
      }
    };

    const submit = () => {
      (async () => {
        try {
          // If the shift is already accepted/rejected, don't show the confirmation dialog
          if (shiftApplication.value.status !== 2) {
            return;
          }
          await ElMessageBox.confirm(
            "Are you sure you want to Accept the shift?",
            "Accept Shift",
            {
              distinguishCancelAndClose: true,
              showConfirmButton: true,
              confirmButtonText: "Accept",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--success",
              cancelButtonClass: "el-button--grey",
              showClose: true,
              center: true,
            }
          );
        } catch {
          return;
        }
        try {
          const response = await $store.dispatch("ACCEPT_REJECT_SHIFT_APPLICATION", {
            shiftApplicationId: shiftApplication.value.id,
            status: "accepted",
          });
          if (response.success) {
            shiftApplication.value.status = response.data.status;
            // dialogVisible.value = true;
            $router.push({
                        name: "locum_shift_preview",
                    });
          } else {
            $router.push({ name: "shift_application_unavailable" });
          }
        } catch (error) {
          console.log(error);
        }
      })();
    };

    const goToSearch = () =>{
      $router.push({ name: "search" });
    }

    const rejectSubmit = () => {
      (async () => {
        try {
          // If the shift is already accepted/rejected, don't show the confirmation dialog
          if (shiftApplication.value.status !== 2) {
            return;
          }
          await ElMessageBox.confirm(
            "Are you sure you want to Decline the shift?",
            "Decline Shift",
            {
              distinguishCancelAndClose: true,
              showConfirmButton: true,
              confirmButtonText: "Decline",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--danger",
              cancelButtonClass: "el-button--grey",
              showClose: true,
              center: true,
            }
          );
        } catch {
          return;
        }
        try {
          const response = await $store.dispatch("ACCEPT_REJECT_SHIFT_APPLICATION", {
            shiftApplicationId: shiftApplication.value.id,
            status: "rejected",
          });

          if (response.success) {
            shiftApplication.value.status = response.data.status;
            // rejectDialogVisible.value = true;
            $router.push({
                        name: "locum_shift_reject_preview",
                    });
          } else {
            $router.push({ name: "shift_application_unavailable" });
          }
        } catch (error) {
          console.log(error);
        }
      })();
    };

    const redirectToCalendar = () => {
      $router.push({ name: "calendar" });
    };

    const isButtonDisabled = computed(() => {
      return shiftApplication.value.status !== 2;
    });

    const handleDialogClose = () => {
      // This function will be called when the dialog is fully closed
      goToSearch()
    };

    const totalSuperRate = (shift) => {
      let confirmedHoursVal = 0;

      if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
        const start = moment(shift.startTime, "HH:mm:ss");
        const end = moment(shift.endTime, "HH:mm:ss");

        confirmedHoursVal = timeDiffAsDecimal(start, end);
      } else {
        confirmedHoursVal = shift.confirmedHours;
      }

      const superRate = shift.payRateSuper * confirmedHoursVal;

      return superRate
        ? Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(superRate)
        : "-";
    };

    return {
      shift,
      job,
      pharmacy,
      userData,
      groupSubscriptionExist,
      userRole,
      formatHourlyRate,
      showShiftInformation,
      travelCompensationCount,
      Sum,
      confirmedHours,
      handleChange,
      Rate,
      submit,
      rejectSubmit,
      dialogVisible,
      rejectDialogVisible,
      redirectToCalendar,
      isButtonDisabled,
      handleDialogClose,
      arrayApplications,
      goBack,
      isAustralia,
      message,
      totalSuperRate,
      checkJobDateStart,
      displayDistance,
      distanceInMiles,
    };
  },
}
</script>